import { DiscountKind } from "common/records/Discount";
import { Record } from "immutable";
import { Nullable } from "common/types";

export const discountBreakdownFromJSON = (data: Partial<IDiscountBreakdown>): DiscountBreakdown => {
  return new DiscountBreakdown(data);
};

export interface IDiscountBreakdown {
  kind: DiscountKind;
  amount: Nullable<number>;
  limit: Nullable<number>;
}

const defaultBreakdownProps: IDiscountBreakdown = {
  kind: "percent",
  amount: 0,
  limit: 0,
};

export class DiscountBreakdown extends Record(defaultBreakdownProps) implements IDiscountBreakdown {}
